// Animal emoji options for avatars - front-facing faces
export const animalEmojis = [
  '🐶',
  '🐱',
  '🐭',
  '🐹',
  '🐰',
  '🦊',
  '🐻',
  '🐼',
  '🐨',
  '🐯',
  '🦁',
  '🐮',
  '🐷',
  '🐸',
  '🐵',
  '🐧',
  '🐺',
  '🐦',
  '🐴',
  '🦄',
];
